var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-1" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Nome do documento:", required: false }
              }),
              _c("el-input", {
                staticClass: "input ellipsis",
                attrs: { disabled: "disabled" },
                model: {
                  value: _vm.documento.nome,
                  callback: function($$v) {
                    _vm.$set(_vm.documento, "nome", $$v)
                  },
                  expression: "documento.nome"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Tipo de documento:", required: false }
              }),
              _c("el-input", {
                staticClass: "input ellipsis",
                attrs: { disabled: "disabled" },
                model: {
                  value: _vm.documento.tipo.nome,
                  callback: function($$v) {
                    _vm.$set(_vm.documento.tipo, "nome", $$v)
                  },
                  expression: "documento.tipo.nome"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Data de envio:", required: false }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: "disabled" },
                model: {
                  value: _vm.dataEnvioFormatada,
                  callback: function($$v) {
                    _vm.dataEnvioFormatada = $$v
                  },
                  expression: "dataEnvioFormatada"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Responsável(eis):", required: false }
              }),
              _c(
                "app-card-disabled",
                [
                  _c("list-responsavel-assinatura", {
                    attrs: { assinadores: _vm.documento.assinadores }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("el-col", { staticClass: "container-input", attrs: { span: 8 } }, [
            _vm.datasAssinatura &&
            _vm.documento.jaAssinadoPorPeloMenosPorUmaPessoa
              ? _c(
                  "div",
                  [
                    _c("app-label", {
                      attrs: { label: "Datas de assinatura:", required: false }
                    }),
                    _c(
                      "app-card-disabled",
                      _vm._l(_vm.datasAssinatura, function(dataAssinatura) {
                        return _c("div", { staticClass: "item-list" }, [
                          _c("span", [_vm._v(_vm._s(dataAssinatura))])
                        ])
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("el-col", { staticClass: "container-input", attrs: { span: 8 } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13f01bff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f01bff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/components/DadosDocumento.vue
// module id = null
// module chunks = 